import PropTypes from 'prop-types'
import {
  PermissionsHeaderContainer,
  PermissionsTitle,
  ExpandCollapseButton,
  StyledExpandAllIcon,
  StyledCollapseAllIcon
} from '../ProjectSectionAccordion/ProjectSectionAccordianStyles'

/**
 * PermissionsHeader
 *
 * Header component for the "All Project Permissions" section.
 * Includes an Expand All / Collapse All toggle button.
 *
 * Props:
 * @param {string} title - Header title (default: "All Project Permissions")
 * @param {boolean} allExpanded - Whether all sections are currently expanded
 * @param {function} onToggleAll - Callback to toggle all sections
 */
const PermissionsHeader = ({title = 'All Project Permissions', allExpanded = false, onToggleAll}) => {
  return (
    <PermissionsHeaderContainer>
      <PermissionsTitle>{title}</PermissionsTitle>
      <ExpandCollapseButton
        onClick={onToggleAll}
        endIcon={allExpanded ? <StyledCollapseAllIcon /> : <StyledExpandAllIcon />}
        aria-label={allExpanded ? 'Collapse all sections' : 'Expand all sections'}
        data-testid='expand-collapse-all-button'
      >
        {allExpanded ? 'Collapse All' : 'Expand All'}
      </ExpandCollapseButton>
    </PermissionsHeaderContainer>
  )
}

PermissionsHeader.propTypes = {
  title: PropTypes.string,
  allExpanded: PropTypes.bool,
  onToggleAll: PropTypes.func.isRequired
}

export default PermissionsHeader
